import React from "react";
import Banner from "../../components/Banner";
import { Sidebar } from "../../components/Sidebar";
import axios from "axios";
import Spinner from "../../components/Spinner";
import "../../css/Wireframe.css";

const API = localStorage.getItem("assethost");

export default class TownCitySettings extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,valid:false,
      msg: "",
      toastColor: "",
      townCities: [],
      editing: false,
      townCityId: 0,
      townCityName: "",
      townCityActiveStatus: "YES",
      page: 0,
      size: 10,
      totalPages: 1,
      errors: {},
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSave = this.handleSave.bind(this);
    this.handleEdit = this.handleEdit.bind(this);
    this.handleCancelEdit = this.handleCancelEdit.bind(this);
    this.handlePreviousPage = this.handlePreviousPage.bind(this);
    this.handleNextPage = this.handleNextPage.bind(this);
    this.validate = this.validate.bind(this);
    this.fetchTownCities = this.fetchTownCities.bind(this);
  }

  componentDidMount() {
    const token = sessionStorage.getItem("token");
    if (!token) {
      this.setState({
        loading: false,
        msg: "No User Token",
        toastColor: "danger",
      });
      sessionStorage.clear();
        window.href = `/?redirectUrl=${
          window.location.pathname + window.location.search
        }`;
      return;
    }
    this.fetchTownCities(0, 10, token);
  }

  fetchTownCities(page, size, token) {
    this.setState({ loading: true, msg: "", toastColor: "" });
    axios
      .get(API + "/settings/getalltowncitys", {
        params: { page, size },
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        let cities = [];
        let totalPages = 1;
        if (response.data && Array.isArray(response.data)) {
          cities = response.data;
        } else if (
          response.data &&
          response.data.content &&
          Array.isArray(response.data.content)
        ) {
          cities = response.data.content;
          totalPages = response.data.totalPages || 1;
        } else {
          cities = [];
        }
        this.setState({
          townCities: cities,
          page,
          totalPages,
          loading: false,
        });
      })
      .catch((error) => {
        if (Number(error.status) === 403) {
          sessionStorage.clear();
          window.href = `/?redirectUrl=${
            window.location.pathname + window.location.search
          }`;
        }
        this.setState({
          townCities: [],
          totalPages: 1,
          loading: false,
          msg: error?.response?.data?.message || "Failed to load town/cities.",
          toastColor: "danger",
        });
      });
  }

  validate() {
    const s = this.state;
    let errors = {};
    let valid = true;

    if (s.editing) {
      if (!s.townCityName || !s.townCityName.trim()) {
        errors.townCityName = "Town/City name is required";
        valid = false;
      }
      if (!s.townCityActiveStatus || !s.townCityActiveStatus.trim()) {
        errors.townCityActiveStatus = "Active status is required";
        valid = false;
      }
    }
    this.setState({ errors, valid });
    return valid;
  }

  handleChange(e) {
    const { name, value } = e.target;
    this.setState({ [name]: value }, this.validate);
  }

  handleSave(e) {
    if (e) e.preventDefault();
    const token = sessionStorage.getItem("token");
    if (!token) {
      this.setState({
        msg: "No user session/token. Please login.",
        toastColor: "danger",
      });
      sessionStorage.clear();
        window.href = `/?redirectUrl=${
          window.location.pathname + window.location.search
        }`;
      return;
    }
    if (!this.validate()) {
      this.setState({
        msg: "Fix the errors above and try again.",
        toastColor: "danger",
      });
      return;
    }
    this.setState({ loading: true, msg: "", toastColor: "" });

    const request = {
      id: this.state.townCityId,
      name: this.state.townCityName,
      activeStatus: this.state.townCityActiveStatus,
    };

    const self = this;
    axios
      .post(API + "/settings/towncitysave", request, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        if (response.data.success) {
          self.setState({
            msg: "Town/City saved successfully!",
            toastColor: "success",
            loading: false,
          });
          // Reset form
          self.setState({
            townCityId: 0,
            townCityName: "",
            townCityActiveStatus: "YES",
            editing: false,
            errors: {},
          });
          // Refetch
          const currentPage = self.state.page;
          self.fetchTownCities(currentPage, self.state.size, token);
        } else {
          self.setState({
            msg: response.data.message || "Failed to save town/city.",
            toastColor: "danger",
            loading: false,
          });
        }
      })
      .catch((error) => {
        if (Number(error.status) === 403) {
          sessionStorage.clear();
          window.href = `/?redirectUrl=${
            window.location.pathname + window.location.search
          }`;
        }
        self.setState({
          msg:
            error?.response?.data?.message ||
            "Failed to save town/city. Please try again.",
          toastColor: "danger",
          loading: false,
        });
      });
  }

  handleEdit(city) {
    if (city && city.id) {
      this.setState(
        {
          editing: true,
          townCityId: city.id,
          townCityName: city.name || "",
          townCityActiveStatus: city.activeStatus || "YES",
          errors: {},
        },
        this.validate
      );
    } else {
      // Add new
      this.setState(
        {
          editing: true,
          townCityId: 0,
          townCityName: "",
          townCityActiveStatus: "YES",
          errors: {},
        },
        this.validate
      );
    }
  }

  handleCancelEdit() {
    this.setState({
      townCityId: 0,
      townCityName: "",
      townCityActiveStatus: "YES",
      editing: false,
      errors: {},
    });
  }

  handlePreviousPage() {
    if (this.state.page > 0) {
      const token = sessionStorage.getItem("token");
      this.fetchTownCities(this.state.page - 1, this.state.size, token);
    }
  }

  handleNextPage() {
    if (this.state.page + 1 < this.state.totalPages) {
      const token = sessionStorage.getItem("token");
      this.fetchTownCities(this.state.page + 1, this.state.size, token);
    }
  }

  render() {
    const s = this.state;
    let divMsg = null;
    if (s.msg) {
      divMsg = (
        <div
          className={
            s.toastColor === "success"
              ? "alert alert-success mx-7"
              : "alert alert-danger mx-7"
          }
        >
          {s.msg}
        </div>
      );
    }

    if (s.loading) {
      return <Spinner className="" />;
    }

    return (
      <div className="min-vh-100 d-flex justify-content-between bg-white">
        <Sidebar />
        <div className="min-vh-100 flex-grow-1 d-flex flex-column">
          <Banner title="Town/City Settings" />
          {divMsg}
          <div className="d-flex flex-column flex-grow-1 px-5 h-60">
            {s.editing ? (
              // Edit/Add Form
              <form
                className="d-flex flex-column align-items-center w-100 mt-2 pt-3 pb-2 h-100 overflow-auto"
                autoComplete="off"
                onSubmit={this.handleSave}
              >
                <div className="row g-3 w-100" style={{maxWidth: 62 + 'rem'}}>
                  <div className="input-group">
                    <label className="input-group-text">Town/City Name</label>
                    <input
                      name="townCityName"
                      className={`form-control ${
                        s.errors.townCityName ? " !border-red-500" : ""
                      }`}
                      value={s.townCityName}
                      onChange={this.handleChange}
                      required
                      autoFocus
                    />
                    {s.errors.townCityName && (
                      <span className="input-group-error">
                        {s.errors.townCityName}
                      </span>
                    )}
                  </div>
                  <div className="input-group">
                    <label className="input-group-text">Active Status</label>
                    <select
                      name="townCityActiveStatus"
                      className={`form-control ${
                        s.errors.townCityActiveStatus ? " !border-red-500" : ""
                      }`}
                      value={s.townCityActiveStatus}
                      onChange={this.handleChange}
                      required
                    >
                      <option value="">Select</option>
                      <option value="YES">Yes</option>
                      <option value="NO">No</option>
                    </select>
                    {s.errors.townCityActiveStatus && (
                      <span className="input-group-error">
                        {s.errors.townCityActiveStatus}
                      </span>
                    )}
                  </div>
                </div>
                <div className="d-flex justify-content-center gap-3 mt-4">
                  {s.valid && (
                    <button type="submit" className="btn btn-primary">
                      Save
                    </button>
                  )}
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={this.handleCancelEdit}
                  >
                    Cancel
                  </button>
                </div>
              </form>
            ) : (
              // Table View
              <div className="h-full w-full">
                <div className="d-flex gap-2 mb-2 align-items-baseline justify-content-between">
                  <h3 className="fw-bold">Configured Towns/Cities</h3>
                  <button
                    className="hover:font-bold flex gap-1 group"
                    onClick={() => this.handleEdit(null)}
                  >
                    <i
                      className="bi bi-plus-circle group-hover:scale-105"
                      style={{ color: "black" }}
                    ></i>
                    Add
                  </button>
                </div>
                {s.townCities.length === 0 ? (
                  <div className="text-muted">No town/cities found.</div>
                ) : (
                  <div className="overflow-x-auto w-full border h-[93%] relative overflow-y-auto">
                    <table className="table table-striped table-hover rounded">
                      <thead className="table-light sticky-top">
                        <tr>
                          <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                            ID
                          </th>
                          <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                            Name
                          </th>
                          <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                            Active Status
                          </th>
                          <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                            Actions
                          </th>
                        </tr>
                      </thead>
                      <tbody className="">
                        {s.townCities.map((city, index) => (
                          <tr key={index} className="hover:bg-gray-50">
                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                              {city.id}
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                              {city.name}
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                              {city.activeStatus}
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
                              <button
                                className="btn btn-primary"
                                onClick={() => this.handleEdit(city)}
                              >
                                Edit
                              </button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
                {s.totalPages > 1 && (
                  <div className="d-flex justify-content-center align-items-center gap-2 mt-4">
                    <button
                      className="btn btn-outline"
                      disabled={s.page === 0}
                      onClick={this.handlePreviousPage}
                    >
                      Previous
                    </button>
                    <span>
                      Page {s.page + 1} of {s.totalPages}
                    </span>
                    <button
                      className="btn btn-outline"
                      disabled={s.page + 1 >= s.totalPages}
                      onClick={this.handleNextPage}
                    >
                      Next
                    </button>
                  </div>
                )}
              </div>
            )}
          </div>
          
        </div>
      </div>
    );
  }
}
